import {
  EDIT_SESSION_START,
  EDIT_SESSION_END,
  EDIT_SESSION_ADD_FEATURE,
  EDIT_SESSION_DELETE_FEATURE,
  EDIT_SESSION_EDIT_FEATURE,
  EDIT_SESSION_EDIT_FEATURES,
  EDIT_SESSION_COPY_FEATURES,
  EDIT_SESSION_FOCUS_ON_FEATURE,
  EDIT_SESSION_GET_FEATURE_BY_ID,
  EDIT_SESSION_VALIDATE_FEATURES,
  EDIT_SESSION_GET_FEATURE_GEOMETRY,
  EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY,
  EDIT_SESSION_CREATE_NEW_FEATURE_FROM_COPIED_FEATURE,
  EDIT_SESSION_GET_OBJECTS_FROM_MAP_SELECTED,
  EDIT_SESSION_RESTORE_DEFAULT_SETTINGS,
  EDIT_SESSION_APPLY_MULTISELECT_MODIFICATATION,
  FEATURES_SHOW_ON_MAP,
  RESET_FOCUSED_FEATURE_ID
  // EDIT_SESSION_CHECK_IF_VALID,
} from './actions.type';

import {
  WINDOW_NOTIFICATION_SHOW,
  // FEATURES_TABLE_TOGGLE,
  FEATURES_SET,
  FEATURE_ADD,
  FEATURE_DELETE,
  FEATURE_EDIT,
  MULTIPLE_FEATURES_EDIT,
  SELECTED_SEARCH_SET_ITEMS,
  EDIT_SESSION_SET_SESSION,
  MANUAL_IMPORT_PANEL_VISIBLE_SET,
  MANUAL_IMPORT_FOCUS_FEATURE_ID_SET,
  EDIT_SESSION_CREATE_MAP_LAYER,
  MANUAL_IMPORT_FEATURES_VALID_RULES_SET,
  MANUAL_IMPORT_FEATURES_VALIDATION_RESULTS_SET,
  MANUAL_IMPORT_MAP_TOOLS_SET,
  MANUAL_IMPORT_FEATURES_VALIDATION_RESULTS,
  EDIT_SESSION_UPDATE_SETTINGS,
  EDIT_SESSION_FEATURES_ARE_COPYING_SET
} from './mutations.type';

// import { Vector as VectorLayer } from 'ol/layer';
// import { Vector as VectorSource } from 'ol/source';
// import { Point, LineString, Polygon } from 'ol/geom';
// import Feature from 'ol/Feature';
// import GeoJSONFormat from 'ol/format/GeoJSON';
// import { bbox } from 'ol/loadingstrategy';
// import Snap from 'ol/interaction/Snap';
import sphere from 'ol/sphere';
// import { extend } from 'ol/extent';
// import AuthInstance from '../api/ContextInstance.js';
// import { getCenter } from 'ol/extent';
// import context from '../api/ContextInstance.js';
import { Polygon } from 'ol/geom';
import { Api as SearchApi } from '../api/api-wyszukiwarka';
import { Api as ApiModele } from '../api/api-modele-jakosci';
import { Api as LayersApi } from '../api/api-warstwy';
const searchApi = new SearchApi();

const layersGeometryColumns = {
  yq: { column: null, name: 'Podmioty obce' },
  xY: { column: ['we09_dlugosc', 'we08_szerokosc'], name: 'Węzły' },
  Kk: {
    column: ['pe10_dlugosc', 'pe09_szerokosc'],
    name: 'Punkty elastyczności'
  },
  eB: { column: ['lk03_punkty_zalamania'], name: 'Linie kablowe' },
  kj: { column: ['sb06_dlugosc', 'sb05_szerokosc'], name: 'Stacje bazowe' },
  LY: { column: null, name: 'Linie bezprzewodowe' },
  NE: { column: null, name: 'Zasięgi ruchomych sieci' },
  je: {
    column: ['ua09_dlugosc', 'ua08_szerokosc'],
    name: 'Usługi punkty adresowe'
  },
  BE: { column: ['bk07_dlugosc', 'bk06_szerokosc'], name: 'Budynki kolokacje' },
  gp: {
    column: ['z_1_ii_2_6'],
    name: 'Infrastruktura techniczna i kanały technologiczne - punktowa'
  },
  Ay: {
    column: ['z_1_iii_2_7'],
    name: 'Infrastruktura techniczna i kanały technologiczne - liniowa'
  },
  oM: {
    column: ['z_1_iv_2_6'],
    name: 'Infrastruktura techniczna i kanały technologiczne - powierzchniowa'
  },
  qJ: {
    column: ['z_2_ii_2_2'],
    name: 'Plany inwestycyjne - infrastruktura punktowa'
  },
  DJ: {
    column: ['z_2_iii_2_2'],
    name: 'Plany inwestycyjne - infrastruktura liniowa'
  },
  '9b': {
    column: ['z_2_iv_2_2'],
    name: 'Plany inwestycyjne - infrastruktura powierzchniowa'
  },
  J1: { column: null, name: 'Kontakty budowlane' },
  OZ: { column: null, name: 'Kontakty infrastruktura' },
  MO: { column: null, name: 'Kontakty drogowe' },
  Ex: { column: null, name: 'Stawki drogowe' }
};

const initialState = {
  // featureIds: [],
  // sessionLayer: null,
  // type: null,
  // waitingForResponse: false,
  // snapRequestControlString: null,
  // selectedFeatureId: null,
  // canPublish: false,
  // replaceGeometryInProgress: false,
  // featureToReplaceClone: undefined,
  editSession: false,
  editSessionLayer: null,
  manualImportPanelVisible: false,
  manualImportfocusFeatureId: null,
  featureIdLength: 8,
  featuresAreCopying: false,
  featuresValidRules: {},
  featuresValidationResults: {},
  selectedSearchItems: [],
  manualImportMapTools: {
    add: false,
    edit: false,
    delete: false
  },
  manualImportSettings: {
    snapLayers: [
      { id: 'xY', snap: true, name: 'Węzły' },
      {
        id: 'Kk',
        snap: true,
        name: 'Punkty elastyczności'
      },
      { id: 'eB', snap: true, name: 'Linie kablowe' },
      {
        id: 'kj',
        column: ['sb06_dlugosc', 'sb05_szerokosc'],
        snap: true,
        name: 'Stacje bazowe'
      },
      { id: 'LY', snap: true, name: 'Linie bezprzewodowe' },
      { id: 'NE', snap: true, name: 'Zasięgi ruchomych sieci' },
      {
        id: 'je',
        snap: true,
        name: 'Usługi punkty adresowe'
      },
      {
        id: 'BE',
        snap: true,
        name: 'Budynki kolokacje'
      },
      {
        id: 'gp',
        snap: true,
        name: 'Infrastruktura techniczna i kanały technologiczne - punktowa'
      },
      {
        id: 'Ay',
        snap: true,
        name: 'Infrastruktura techniczna i kanały technologiczne - liniowa'
      },
      {
        id: 'oM',
        snap: true,
        name:
          'Infrastruktura techniczna i kanały technologiczne - powierzchniowa'
      },
      {
        id: 'qJ',
        snap: true,
        name: 'Plany inwestycyjne - infrastruktura punktowa'
      },
      {
        id: 'DJ',
        snap: true,
        name: 'Plany inwestycyjne - infrastruktura liniowa'
      },
      {
        id: '9b',
        snap: true,
        name: 'Plany inwestycyjne - infrastruktura powierzchniowa'
      }
    ],
    snapRange: 10,
    itemsPerPage: 10,
    maximumInventarizationFeatures: 20000,
    tableRawData: false,
    multiselectModification: {
      notification: true,
      value: true
    }
  },
  manualImportDefaultSettings: {
    snapLayers: [
      { id: 'xY', snap: true, name: 'Węzły' },
      {
        id: 'Kk',
        snap: true,
        name: 'Punkty elastyczności'
      },
      { id: 'eB', snap: true, name: 'Linie kablowe' },
      {
        id: 'kj',
        column: ['sb06_dlugosc', 'sb05_szerokosc'],
        snap: true,
        name: 'Stacje bazowe'
      },
      { id: 'LY', snap: true, name: 'Linie bezprzewodowe' },
      { id: 'NE', snap: true, name: 'Zasięgi ruchomych sieci' },
      {
        id: 'je',
        snap: true,
        name: 'Usługi punkty adresowe'
      },
      {
        id: 'BE',
        snap: true,
        name: 'Budynki kolokacje'
      },
      {
        id: 'gp',
        snap: true,
        name: 'Infrastruktura techniczna i kanały technologiczne - punktowa'
      },
      {
        id: 'Ay',
        snap: true,
        name: 'Infrastruktura techniczna i kanały technologiczne - liniowa'
      },
      {
        id: 'oM',
        snap: true,
        name:
          'Infrastruktura techniczna i kanały technologiczne - powierzchniowa'
      },
      {
        id: 'qJ',
        snap: true,
        name: 'Plany inwestycyjne - infrastruktura punktowa'
      },
      {
        id: 'DJ',
        snap: true,
        name: 'Plany inwestycyjne - infrastruktura liniowa'
      },
      {
        id: '9b',
        snap: true,
        name: 'Plany inwestycyjne - infrastruktura powierzchniowa'
      }
    ],
    snapRange: 10,
    itemsPerPage: 10,
    maximumInventarizationFeatures: 20000,
    tableRawData: false,
    multiselectModification: {
      notification: true,
      value: true
    }
  }
};

// const sessionApi = new SessionApi();
// const hybridLayersApi = new HybridLayersApi();
// const dataFeedApi = new DataFeedApi();

// var postSesjeEdycyjneByIdEdytowanyControl = null;

export const state = Object.assign({}, initialState);

export const actions = {
  [EDIT_SESSION_START](context) {
    const activeLayer = context.getters.activeLayer;
    if (activeLayer && activeLayer.isSystem) {
      if (activeLayer.readOnly) {
        context.commit(WINDOW_NOTIFICATION_SHOW, {
          type: 'warn',
          title: 'Uwaga. Wybrana warstwa jest warstwą tylko do odczytu.',
          message: 'Nie można edytować warstwy tylko do odczytu.',
          duration: 5000
        });
      } else {
        context.commit(EDIT_SESSION_CREATE_MAP_LAYER, true);
        // context.commit(FEATURES_SET, []);

        context.commit(EDIT_SESSION_SET_SESSION, true);
        context.commit(MANUAL_IMPORT_PANEL_VISIBLE_SET, true);
        // getModeleJakosciByIdWarstwy(context, activeLayerId);
      }
    } else {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Uwaga. Nie wybrano warstwy aktywnej.',
        message:
          'Aby rozpocząć edycję elementów należy wybrać warstwę aktywną.',
        duration: 5000
      });
    }
  },
  [EDIT_SESSION_END](context) {
    context.commit(FEATURES_SET, []);
    context.commit(EDIT_SESSION_SET_SESSION, false);
    context.commit(MANUAL_IMPORT_PANEL_VISIBLE_SET, false);
  },

  /**
   * Add feature in edit session
   * @method Api#EDIT_SESSION_ADD_FEATURE
   * @param {object} attributes - object with attributes-optional
   */
  async [EDIT_SESSION_ADD_FEATURE](context, attributes) {
    const layerId = attributes.layer || context.getters.activeLayer.id;
    const columns = context.getters.featuresColumns[layerId];
    const newFeature = {};

    columns.forEach(column => {
      const value = attributes && attributes[column.key];
      if (value) {
        newFeature[column.key] = value;
      } else {
        newFeature[column.key] = column.dictionary === '2' ? [] : '';
      }
    });

    if (attributes) {
      newFeature.selected = attributes.selected ? attributes.selected : false;
      newFeature.id = attributes.id ? attributes.id : generateId(8);
      newFeature.visible =
        typeof attributes.visible !== 'undefined' ? attributes.visible : true;
      newFeature.layer = layerId;
    }

    context.commit(FEATURE_ADD, newFeature);
  },

  async [EDIT_SESSION_DELETE_FEATURE](context, featureId) {
    context.commit(FEATURE_DELETE, featureId);
  },
  [EDIT_SESSION_EDIT_FEATURE](context, updatedFeature) {
    context.commit(FEATURE_EDIT, updatedFeature);
  },
  [EDIT_SESSION_EDIT_FEATURES](context, updatedFeatures) {
    context.commit(MULTIPLE_FEATURES_EDIT, updatedFeatures);
  },

  async [EDIT_SESSION_COPY_FEATURES](context, payload) {
    context.commit(EDIT_SESSION_FEATURES_ARE_COPYING_SET, true);
    context.commit(WINDOW_NOTIFICATION_SHOW, {
      type: 'info',
      title: 'Informacja.',
      message: `Rozpoczęto proces kopiowania. Proszę czekać.`,
      duration: 5000,
      changedDuration: 5000
    });

    const drawLayerFeatures = context.getters.drawLayer
      ? context.getters.drawLayer.getSource().getFeatures()
      : null;
    if (drawLayerFeatures) {
      // let isFeaturesValidGeometryType = true;
      let isFeaturesFromOnlyOneLayer =
        context.getters.layers.filter(
          layer => layer.group == 'systemowa' && layer.visible == true
        ).length === 1;

      let isCopyLayerGeometryTypeCorrect =
        context.getters.layers.find(
          layer => layer.group == 'systemowa' && layer.visible == true
        ).type === context.getters.activeLayer.type;

      if (isFeaturesFromOnlyOneLayer && isCopyLayerGeometryTypeCorrect) {
        await context.dispatch(
          EDIT_SESSION_GET_OBJECTS_FROM_MAP_SELECTED,
          drawLayerFeatures[0]
        );
        if (state.selectedSearchItems) {
          const activeLayerFeatures = state.selectedSearchItems.filter(
            feature => {
              return feature.layerId === context.getters.activeLayer.id;
            }
          );
          await Promise.all(
            activeLayerFeatures.map(async selectedSearchItem => {
              await context.dispatch(
                EDIT_SESSION_CREATE_NEW_FEATURE_FROM_COPIED_FEATURE,
                selectedSearchItem
              );
            })
          );
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'success',
            title: 'Sukces.',
            message: `Skopiowano ${activeLayerFeatures.length} obiektów.`,
            duration: 10000,
            changedDuration: 10000
          });
        } else {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'warn',
            title: 'Uwaga. Brak obiektów do skopiowania',
            message:
              'W zaznaczonym obszarze nie odnaleziono obiektów do skopiowania.',
            duration: 10000,
            changedDuration: 10000
          });
        }
      } else {
        if (!isFeaturesFromOnlyOneLayer) {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'warn',
            title: 'Uwaga. Zaznaczone elementy pochodzą z wielu warstw',
            message:
              'Kopiowanie może być wykonane tylko gdy zaznaczone elementy pochodzą z jednej warstwy.',
            duration: 10000,
            changedDuration: 10000
          });
        }
        if (!isCopyLayerGeometryTypeCorrect) {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'warn',
            title:
              'Uwaga. Zaznaczone elementy pochodzą z warstwy o innym typie geometrii',
            message:
              'Kopiowanie może być wykonane tylko z warstwy o tym samym typie geometrii np. podczas edycji warstwy punktowej można kopiować tylko z warstw punktowych.',
            duration: 10000,
            changedDuration: 10000
          });
        }
      }
    } else {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Uwaga. Nie zaznaczono elementów do skopiowania',
        message:
          'Kopiowanie elementów może być wykonane tylko gdy zaznaczono elementy z widocznych warstw systemowych.',
        duration: 10000,
        changedDuration: 10000
      });
    }
    context.commit(EDIT_SESSION_FEATURES_ARE_COPYING_SET, false);
  },
  async [EDIT_SESSION_FOCUS_ON_FEATURE](context, featureId) {
    let feature = null;
    if (featureId) {
      feature = await context.dispatch(
        EDIT_SESSION_GET_FEATURE_BY_ID,
        featureId
      );
    }

    if (feature) {
      context.commit(MANUAL_IMPORT_FOCUS_FEATURE_ID_SET, featureId);
    } else {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'error',
        title: 'Uwaga.',
        message:
          'Nie można przybliżyć do podanego obiektu- nie można zidentyfikować obiektu.'
      });
    }
  },
  async [EDIT_SESSION_GET_OBJECTS_FROM_MAP_SELECTED](context, selectedFeature) {
    context.commit(SELECTED_SEARCH_SET_ITEMS, []);
    const filteredLayers = context.getters.layers.filter(
      layer => layer.group == 'systemowa' && layer.visible == true
    );
    const layersRequestData = [
      { id: 'LY', name: 'pit:vlinie_bezprzewodowe', geometryCol: 'geom' },
      {
        id: 'eB',
        name: 'pit:gc_linie_kablowe',
        geometryCol: 'lk03_punkty_zalamania'
      },
      {
        id: 'Ay',
        name: 'pit:gc_liniowa_istniejaca',
        geometryCol: 'z_1_iii_2_7'
      },
      {
        id: 'DJ',
        name: 'pit:gc_liniowa_planowana',
        geometryCol: 'z_2_iii_2_2'
      },
      {
        id: 'oM',
        name: 'pit:gc_powierzchniowa_istniejaca',
        geometryCol: 'z_1_iv_2_6'
      },
      {
        id: '9b',
        name: 'pit:gc_powierzchniowa_planowana',
        geometryCol: 'z_2_iv_2_2'
      },
      {
        id: 'gp',
        name: 'pit:gc_punktowa_istniejaca',
        geometryCol: 'z_1_ii_2_6'
      },
      {
        id: 'qJ',
        name: 'pit:gc_punktowa_planowana',
        geometryCol: 'z_2_ii_2_2'
      },
      {
        id: 'Kk',
        name: 'pit:gc_punkty_elastycznosci',
        geometryCol: 'pe00_lokalizacja'
      },
      {
        id: 'kj',
        name: 'pit:gc_stacje_bazowe',
        geometryCol: 'sb00_lokalizacja'
      },
      {
        id: 'je',
        name: 'pit:gc_uslugi_pkt_adr',
        geometryCol: 'ua00_lokalizacja'
      },
      { id: 'xY', name: 'pit:gc_wezly', geometryCol: 'we00_lokalizacja' },
      { id: 'NE', name: 'pit:gc_zasiegi_ruchomych_sieci', geometryCol: 'geom' }
    ];
    //konfiguracja nazw kolumn w postaci nazwa_warstwy.nazwa_atrybutu: tytuł

    // context.commit(SEARCH_WFS_SET_RESULT, null);
    let copiedFeatures = [];
    const selectedFeaturePolygon = selectedFeature
      .getGeometry()
      .getCoordinates()[0];
    const formattedCoordinates = selectedFeaturePolygon
      .map(coord => `${coord[0]} ${coord[1]}`)
      .join(', ');
    const wktPolygon = `POLYGON((${formattedCoordinates}))`;
    //  filteredLayers.forEach( filteredLayer => {
    let singleLayerCopiedFeatures = [];
    if (filteredLayers) {
      for (let i = 0; i < filteredLayers.length; i++) {
        const layerRequestData = layersRequestData.find(el => {
          if (el.id == filteredLayers[i].id) {
            return el;
          }
        });
        try {
          if (layerRequestData) {
            const parameters = {
              count: 10000,
              maxfeatures: 10000,
              typeNames: layerRequestData.name,
              cql_filter: `intersects(${layerRequestData.geometryCol},${wktPolygon})`
            };
            const result = await searchApi.getFeaturesInPolygonFromAnyLayer(
              parameters
            );

            if (
              result &&
              result.body &&
              result.body.features &&
              result.body.features.length > 0
            ) {
              let features = result.body.features;

              for (var j = 0; j < features.length; j++) {
                let coopiedFeature = {};
                coopiedFeature.coordinates = features[j].geometry.coordinates;
                coopiedFeature.type = features[j].geometry.type;
                coopiedFeature.element_uuid =
                  features[j].properties.element_uuid;
                coopiedFeature.element_uuid =
                  features[j].properties.element_uuid;
                coopiedFeature.layerId = filteredLayers[i].id;
                // wfsItems.push(coopiedFeature);
                singleLayerCopiedFeatures.push(coopiedFeature);
              }

              //listy obiektów tworzone są dla konkretnych warstw więc trzeba połączyć też wszystkie i razem wyświetlać
            } else {
              context.commit(WINDOW_NOTIFICATION_SHOW, {
                type: 'warn',
                title: 'Uwaga. Brak obiektów do skopiowania',
                message:
                  'W zaznaczonym obszarze nie odnaleziono obiektów do skopiowania.',
                duration: 10000,
                changedDuration: 10000
              });
            }
          }
        } catch (error) {
          context.commit(WINDOW_NOTIFICATION_SHOW, {
            type: 'warn',
            title:
              'Pobieranie danych o obiektach na obszarze nie powiodło się.',
            message: error + 'layerId: ' + layerRequestData.id,
            duration: 5000
          });
        }
      }
    } else {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type: 'warn',
        title: 'Uwaga. Nie wybrano warstwy wyszukiwania.',
        message:
          'Kopiowanie obiektów możliwe jest tylko po wybraniu odpowiedniej warstwy systemowej.',
        duration: 5000
      });
    }
    copiedFeatures.push(...(singleLayerCopiedFeatures || []));
    context.commit(SELECTED_SEARCH_SET_ITEMS, singleLayerCopiedFeatures);
    // });
  },
  async [EDIT_SESSION_VALIDATE_FEATURES](context) {
    const showNotification = (type, title, message) => {
      context.commit(WINDOW_NOTIFICATION_SHOW, {
        type,
        title,
        message,
        duration: 5000,
        changedDuration: 5000
      });
    };

    const getValidationResults = async (
      item,
      columns,
      activeLayerColumns,
      features
    ) => {
      const validationObj = {};

      for (const column of columns) {
        const activeLayerColumn = activeLayerColumns.kolumny.find(
          col => col.nazwa === column.key
        );

        if (!activeLayerColumn) continue;

        const validationRules = context.getters.featuresValidRules[column.key];
        const validationResults = await validateColumn(
          item,
          column,
          activeLayerColumn,
          validationRules,
          features
        );

        validationObj[column.key] = validationResults;
      }

      return validationObj;
    };

    const validateColumn = async (
      item,
      column,
      activeLayerColumn,
      rules,
      features
    ) => {
      let isValid = true;
      let description = '';
      let type = 'Info';

      for (const rule of rules) {
        const {
          isValid: ruleValid,
          description: ruleDesc,
          type: ruleType
        } = await validateRule(item, column, rule, features);
        if (!ruleValid) {
          isValid = false;
          description = ruleDesc;
          type = ruleType;
          break;
        }
      }

      return { isValid, description, type };
    };

    const validateRule = async (item, column, rule, features) => {
      // Example: Add more specific rule handling as needed
      switch (rule.type) {
        case 'RegExp':
          const regex = new RegExp(rule.rule.split(':')[1]);
          if (!regex.test(item[column.key])) {
            return {
              isValid: false,
              description: rule.description,
              type: 'Error'
            };
          }
          break;

        case 'GeometryCheck':
          const geometry = await context.dispatch(
            EDIT_SESSION_GET_FEATURE_GEOMETRY,
            item
          );
          if (!geometry) {
            return {
              isValid: false,
              description: rule.description,
              type: 'Error'
            };
          }
          break;

        // Additional rules...
      }

      return { isValid: true, description: '', type: 'Info' };
    };

    showNotification(
      'info',
      'Informacja.',
      'Rozpoczęto proces walidacji danych. Proszę czekać.'
    );

    const columns = context.getters.featuresColumns;
    const features = context.getters.features;
    const activeLayer = context.getters.activeLayer;
    const activeLayerColumns = context.getters.tableMeta.find(
      meta => meta.id === activeLayer.id
    );
    const validationResults = {};

    for (const feature of features) {
      validationResults[feature.id] = await getValidationResults(
        feature,
        columns[feature.layer],
        activeLayerColumns,
        features
      );
    }

    context.commit(
      MANUAL_IMPORT_FEATURES_VALIDATION_RESULTS_SET,
      validationResults
    );
    showNotification(
      'success',
      'Sukces.',
      'Zakończono proces walidacji danych.'
    );
  },
  [EDIT_SESSION_GET_FEATURE_GEOMETRY](context, feature) {
    const getGeometryDetails = () => {
      if (feature.layer) {
        const columns =
          context.getters.layersGeometryColumns[feature.layer] &&
          context.getters.layersGeometryColumns[feature.layer].column;
        const matchingLayer =
          context.getters.layers &&
          context.getters.layers.find(layer => layer.id === feature.layer);
        const layerType = matchingLayer ? matchingLayer.type : null;

        return { columns, layerType };
      }

      const columns =
        context.getters.activeLayerGeometryColumns &&
        context.getters.activeLayerGeometryColumns.column;
      const layerType = context.getters.activeLayer
        ? context.getters.activeLayer.type
        : null;

      return { columns, layerType };
    };

    let resultArray = null;
    const { columns, layerType } = getGeometryDetails();

    if (!columns) return -1;

    const getCoordinatesFromString = (regex, geometryString, mapper) => {
      const match = geometryString && geometryString.match(regex);
      if (match) {
        return match[1]
          .split(',')
          .map(coord => {
            const [x, y] = coord
              .trim()
              .split(' ')
              .map(parseFloat);
            return mapper(x, y);
          })
          .filter(coord => coord !== null);
      }
      return null;
    };

    const isValidCoordinate = (x, y) => x >= 0 && y >= 0;

    switch (layerType) {
      case 'point':
        if (columns.length === 1) {
          const regex = /^point\s*\((-?\d+(\.\d+)?)\s(-?\d+(\.\d+)?)\)$/i;
          const match = feature[columns[0]] && feature[columns[0]].match(regex);
          if (match) {
            const x = parseFloat(match[1]);
            const y = parseFloat(match[3]);
            if (isValidCoordinate(x, y)) {
              resultArray = [x, y];
            }
          }
        } else if (columns.length === 2) {
          const regex = /^-?\d+(\.\d+)?$/;
          const x = parseFloat(feature[columns[0]]) || null;
          const y = parseFloat(feature[columns[1]]) || null;
          if (regex.test(x) && regex.test(y) && isValidCoordinate(x, y)) {
            resultArray = [x, y];
          }
        }
        break;

      case 'linestring':
        const lineStringRegex = /^LINESTRING\s*\(\s*((-?\d+(\.\d+)?)\s(-?\d+(\.\d+)?)(,\s*-?\d+(\.\d+)?\s-?\d+(\.\d+)?)+)\s*\)$/i;
        const geometryColumn = columns[0];
        const coordinates = getCoordinatesFromString(
          lineStringRegex,
          feature[geometryColumn],
          (x, y) => {
            return isValidCoordinate(x, y) ? [x, y] : null;
          }
        );
        if (coordinates && coordinates.length) {
          resultArray = coordinates;
        }
        break;

      case 'polygon':
        const polygonRegex = /^POLYGON\s*\(\s*\(\s*((-?\d+(\.\d+)?)\s(-?\d+(\.\d+)?)(,\s*-?\d+(\.\d+)?\s-?\d+(\.\d+)?)+)\s*\)\s*\)$/i;
        const polygonCoordinates = getCoordinatesFromString(
          polygonRegex,
          feature[columns[0]],
          (x, y) => {
            return isValidCoordinate(x, y) ? [x, y] : null;
          }
        );
        if (polygonCoordinates && polygonCoordinates.length) {
          // Ensure the polygon is closed
          const first = polygonCoordinates[0];
          const last = polygonCoordinates[polygonCoordinates.length - 1];
          if (first[0] === last[0] && first[1] === last[1]) {
            resultArray = [polygonCoordinates];
          }
        }
        break;
    }

    return resultArray;
  },
  [EDIT_SESSION_TRANSFORM_GEOMETRY_TO_FEATURE_GEOMETRY](context, payload) {
    const getParameters = (payload, context) => {
      const geometry = payload.geometry || payload;
      const feature = payload.geometry ? payload.feature : undefined;
      const geometryColumns = feature
        ? context.getters.layersGeometryColumns[feature.get('layer')].column
        : context.getters.activeLayerGeometryColumns.column;
      const layerType = feature
        ? feature
            .getGeometry()
            .getType()
            .toLowerCase()
        : context.getters.activeLayer.type;

      return { geometry, geometryColumns, layerType };
    };

    const transformPoint = () => {
      if (geometryColumns.length === 1) {
        featureGeometry[
          geometryColumns[0]
        ] = `POINT(${geometry[0]} ${geometry[1]})`;
      } else if (geometryColumns.length === 2) {
        featureGeometry[geometryColumns[0]] = geometry[0];
        featureGeometry[geometryColumns[1]] = geometry[1];
      }
    };

    const transformLineString = () => {
      const coordinates = geometry.map(([x, y]) => `${x} ${y}`).join(', ');
      featureGeometry[geometryColumns[0]] = `LINESTRING(${coordinates})`;
    };

    const transformPolygon = () => {
      const polygonStrings = geometry
        .map(polygon => polygon.map(([x, y]) => `${x} ${y}`).join(', '))
        .join('), (');
      featureGeometry[geometryColumns[0]] = `POLYGON((${polygonStrings}))`;
    };

    const { geometry, geometryColumns, layerType } = getParameters(
      payload,
      context
    );

    const featureGeometry = {};

    switch (layerType) {
      case 'point':
        transformPoint();
        break;
      case 'linestring':
        transformLineString();
        break;
      case 'polygon':
        transformPolygon();
        break;
    }
    return featureGeometry;
  },
  [EDIT_SESSION_GET_FEATURE_BY_ID](context, featureId) {
    return context.getters.features.find(feature => {
      return feature.id == featureId;
    });
  },
  async [EDIT_SESSION_CREATE_NEW_FEATURE_FROM_COPIED_FEATURE](
    context,
    feature
  ) {
    const coordinates = feature.coordinates;

    let newFeature = {};
    let geometryColumn = null;
    let geometryCenterCoordinates = null;

    switch (context.getters.activeLayer.type) {
      case 'point':
        geometryCenterCoordinates = coordinates;
        if (context.getters.activeLayerGeometryColumns.column.length == 1) {
          geometryColumn = context.getters.activeLayerGeometryColumns.column[0];
          newFeature[
            geometryColumn
          ] = `POINT(${coordinates[0]} ${coordinates[1]})`;
        }
        if (context.getters.activeLayerGeometryColumns.column.length == 2) {
          const geometryColumn1 =
            context.getters.activeLayerGeometryColumns.column[0];
          const geometryColumn2 =
            context.getters.activeLayerGeometryColumns.column[1];
          newFeature[geometryColumn1] = coordinates[0];
          newFeature[geometryColumn2] = coordinates[1];
        }
        break;
      case 'linestring':
        geometryColumn = context.getters.activeLayerGeometryColumns.column[0];
        const coordinateStrings = coordinates.map(
          coord => `${coord[0]} ${coord[1]}`
        );
        const coordinateString = coordinateStrings.join(', ');
        //eb is linie kablove and they have diferent geometry write
        // if (
        //   state.activeLayer.id == 'eB' &&
        //   !coordinateString.toLowerCase().includes('linestring')
        // ) {
        //   newFeature[geometryColumn] = coordinateString;
        // } else {
        newFeature[geometryColumn] = `LINESTRING(${coordinateString})`;
        // }
        break;
      case 'polygon':
        geometryColumn = context.getters.activeLayerGeometryColumns.column[0];
        const polygonStrings = coordinates.map(polygon =>
          polygon.map(coord => `${coord[0]} ${coord[1]}`).join(', ')
        );
        const polygonString = `POLYGON((${polygonStrings.join('), (')}))`;
        newFeature[geometryColumn] = polygonString;
        break;
    }
    // if (feature.layerId === state.activeLayer.id) {
    const layer = context.getters.layers.find(l => l.id === feature.layerId)
    const attributes = await getFeatureAttributes(
      layer != null ? (layer.parentId || layer.id) : feature.layerId,
      feature.element_uuid
    );
    const tableMeta = context.getters.tableMeta;

    const activeLayerColumns = tableMeta.find(
      obj => obj.id === context.getters.activeLayer.id
    );
    await Promise.all(
      Object.keys(attributes).map(atributeKey => {
        const activeLayerColumn = activeLayerColumns.kolumny.find(kolumna => {
          return atributeKey == kolumna.nazwa;
        });
        let dictionary = null;
        switch (activeLayerColumn.slownik) {
          case '0':
            break;
          case '1':
            if (attributes[atributeKey]) {
              dictionary = context.getters.dictionaries.find(dictionary => {
                return dictionary.nazwa == activeLayerColumn.nazwa_slownika;
              });
              attributes[atributeKey] = dictionary.pola.find(
                dictionaryFielf => {
                  return dictionaryFielf.position == attributes[atributeKey];
                }
              ).value;
            }
            break;
          case '2':
            if (attributes[atributeKey]) {
              dictionary = context.getters.dictionaries.find(dictionary => {
                return dictionary.nazwa == activeLayerColumn.nazwa_slownika;
              });
              attributes[atributeKey] = attributes[atributeKey]
                .split(';')
                .map(value => {
                  return (
                    dictionary.pola.find(dictionaryFielf => {
                      return dictionaryFielf.position == value;
                    }).value || null
                  );
                });
            }
            break;
          case '3':
            break;
        }

        // const dictionary = context.getters.dictionaries.find(
        //   dictionary => {
        //     return (
        //       dictionary.nazwa ==
        //       activeLayerColumn.nazwa_slownika
        //     );
        //   }
        // );
        // if (isNaN(attributes[atributeKey])) {
        // } else {
        //   attributes[atributeKey] = parseInt(attributes[atributeKey]);
        // }
      })
    );
    newFeature = { ...newFeature, ...attributes };
    // }
    newFeature.validGeometry = true;
    newFeature.center = geometryCenterCoordinates;

    context.dispatch(EDIT_SESSION_ADD_FEATURE, newFeature);
    function adjustFetchedAtributes() {}
  },
  [EDIT_SESSION_RESTORE_DEFAULT_SETTINGS](context) {
    context.commit(
      EDIT_SESSION_UPDATE_SETTINGS,
      state.manualImportDefaultSettings
    );
  },
  [EDIT_SESSION_APPLY_MULTISELECT_MODIFICATATION](context, data) {
    const fieldToModify = data.field.key;
    const modifyiedValue = data.value;
    const featuresToModify = context.getters.features.filter(feature => {
      return feature.selected && feature.visible;
    });
    featuresToModify.forEach(feature => {
      context.commit(FEATURE_EDIT, {
        ...feature,
        [fieldToModify]: modifyiedValue
      });
    });
  },
  [RESET_FOCUSED_FEATURE_ID](context) {
    context.commit(MANUAL_IMPORT_FOCUS_FEATURE_ID_SET, null);
  }
};

export const getters = {
  manualImportPanelVisible() {
    return state.manualImportPanelVisible;
  },
  editSession() {
    return state.editSession;
  },
  manualImportSettings() {
    return state.manualImportSettings;
  },
  featureIdLength() {
    return state.featureIdLength;
  },
  featuresValidRules() {
    return state.featuresValidRules;
  },
  featuresValidationResults() {
    return state.featuresValidationResults;
  },
  manualImportSettings() {
    return state.manualImportSettings;
  },
  layersGeometryColumns() {
    return layersGeometryColumns;
  },
  activeLayerGeometryColumns(_state, getters) {
    if (getters.activeLayer) {
      return layersGeometryColumns[getters.activeLayer.id];
    }
  },
  manualImportMapTools() {
    return state.manualImportMapTools;
  },
  featuresAreCopying() {
    return state.featuresAreCopying;
  },

  manualImportfocusFeatureId() {
    return state.manualImportfocusFeatureId;
  }
};

export const mutations = {
  [MANUAL_IMPORT_PANEL_VISIBLE_SET](state, value) {
    state.manualImportPanelVisible = value;
  },
  [MANUAL_IMPORT_FOCUS_FEATURE_ID_SET](state, manualImportfocusFeatureId) {
    state.manualImportfocusFeatureId = manualImportfocusFeatureId;
  },
  [EDIT_SESSION_SET_SESSION](state, value) {
    state.editSession = value;
  },
  [EDIT_SESSION_CREATE_MAP_LAYER](state, useBbox) {},
  [MANUAL_IMPORT_FEATURES_VALID_RULES_SET](state, featuresValidRules) {
    state.featuresValidRules = featuresValidRules;
  },
  [SELECTED_SEARCH_SET_ITEMS](state, value) {
    state.selectedSearchItems = value || [];
  },
  [MANUAL_IMPORT_FEATURES_VALIDATION_RESULTS_SET](
    state,
    featuresValidationResults
  ) {
    state.featuresValidationResults = featuresValidationResults;
  },
  [MANUAL_IMPORT_MAP_TOOLS_SET](state, mapTool) {
    switch (mapTool) {
      case 'add':
        state.manualImportMapTools = {
          add: true,
          edit: false,
          delete: false,
          select: false
        };
        break;
      case 'edit':
        state.manualImportMapTools = {
          add: false,
          edit: true,
          delete: false,
          select: false
        };
        break;
      case 'delete':
        state.manualImportMapTools = {
          add: false,
          edit: false,
          delete: true
        };
        break;
      case 'select':
        state.manualImportMapTools = {
          add: false,
          edit: false,
          delete: false,
          select: true
        };
        break;
      case null:
        state.manualImportMapTools = {
          add: false,
          edit: false,
          delete: false,
          select: false
        };
        break;
      default:
        state.manualImportMapTools = {
          add: false,
          edit: false,
          delete: false,
          select: false
        };
        break;
    }
  },
  [EDIT_SESSION_UPDATE_SETTINGS](state, newSettseings) {
    state.manualImportSettings = newSettseings;
  },
  [EDIT_SESSION_FEATURES_ARE_COPYING_SET](state, value) {
    state.featuresAreCopying = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
async function getModeleJakosciByIdWarstwy(context, id) {
  try {
    const api = new ApiModele();
    const response = await api.getModeleJakosciByIdWarstwy({
      wso2_id: context.contextEmail,
      orgid: context.contextOrganizationId,
      id: id
    });
    if (response) {
      const featuresValidRules = response.body.modele_jakosci.reguly_jakosci.reduce(
        (obj, item) => {
          if (!obj[item.Field]) {
            obj[item.Field] = [];
          }

          const newObjItem = item;
          obj[item.Field].push(newObjItem);

          return obj;
        },
        {}
      );

      context.commit(
        MANUAL_IMPORT_FEATURES_VALID_RULES_SET,
        featuresValidRules
      );
    }
  } catch (error) {
    context.commit(WINDOW_NOTIFICATION_SHOW, {
      message: error,
      type: 'error',
      title: 'Uwaga.'
    });
  }
}
async function getFeatureAttributes(layerId, obiektId) {
  try {
    const layersApi = new LayersApi();
    const response = await layersApi.getFeatureAttributesById({
      wso2_id: localStorage.getItem('contextEmail') || null,
      orgid: localStorage.getItem('orgId') || null,
      layerId: layerId,
      obiektId: obiektId
    });
    if (response) {
      return response.body.atrybuty || {};
    } else {
      return {};
    }
  } catch (error) {
    state.commit(WINDOW_NOTIFICATION_SHOW, {
      type: 'error',
      title: 'Uwaga. Błąd przy odczytywaniu atrybutów.',
      message: 'Odczytywanie atrybutów dla wybranego obiektu nie powiodło się.',
      duration: 5000
    });
    return {};
  }
}
function generateId(length = 8) {
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let id = '';

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    id += chars.charAt(randomIndex);
  }

  return id;
}
